import { observable, selector } from '@poa/state';
import moment from 'moment';
import { ACCESS_LEVEL, GRANTED_HOSTS } from '../auth/auth.constants';
import { filteredData, isAllColumnsSelected } from './reports.selectors';

const columns = [
  {
    name: 'panel',
    label: 'Панель',
    width: 75,
    isSelected: true,
    sectionId: 'section_1'
  },
  {
    name: 'status',
    label: 'С',
    width: 25,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'photo',
    label: 'Фото',
    width: 60,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'full_name',
    label: 'ФИО',
    width: 140,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'manager',
    label: 'Менеджер',
    width: 140,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'team_lead',
    label: 'Тимлид',
    width: 120,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'operator',
    label: 'Оператор',
    width: 140,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'scout',
    label: 'Скаут',
    width: 140,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: '@@separator3',
    label: '—',
    isSelected: true
  },
  {
    name: 'form_level',
    label: 'Уровень',
    width: 80,
    sectionId: 'section_1',
    isSelected: true,
    editable: false
  },
  {
    name: 'nick',
    label: 'Ник',
    width: 130,
    sectionId: 'section_2',
    isSelected: true
  },
  {
    name: 'id',
    label: 'ID',
    width: 90,
    sectionId: 'section_2',
    isSelected: true
  },
  {
    name: 'number',
    label: '№',
    width: 100,
    sectionId: 'section_2',
    isSelected: true
  },
  {
    name: '@@separator2',
    label: '—',
    isSelected: true
  },
  {
    name: 'card',
    label: 'карта',
    width: 145,
    sectionId: 'section_3',
    isSelected: false
  },
  {
    name: '@@separator1',
    label: '—',
    isSelected: true
  },
  {
    name: 'total',
    label: '$',
    width: 60,
    sectionId: 'section_4',
    aggregation_type: 'sum',
    isSelected: true
  },
  {
    name: 'plan',
    label: 'план',
    width: 60,
    sectionId: 'section_4',
    aggregation_type: 'sum',
    isSelected: true
  },
  {
    name: 'fee',
    label: '-%',
    width: 60,
    sectionId: 'section_4',
    aggregation_type: 'sum',
    isSelected: true
  },
  {
    name: 'clear',
    label: 'чист.',
    width: 60,
    sectionId: 'section_4',
    aggregation_type: 'sum',
    isSelected: true
  },
  {
    name: 'manager_income',
    label: 'мен.',
    width: 60,
    sectionId: 'section_4',
    aggregation_type: 'sum',
    isSelected: true
  },
  {
    name: 'teamlead',
    label: 'тим.',
    width: 60,
    sectionId: 'section_4',
    aggregation_type: 'sum',
    isSelected: true
  },
  {
    name: 'operator_income',
    label: 'опер.',
    width: 60,
    sectionId: 'section_4',
    aggregation_type: 'sum',
    isSelected: true
  },
  {
    name: 'account_income',
    label: 'акк.',
    width: 60,
    sectionId: 'section_4',
    aggregation_type: 'sum',
    isSelected: true
  },
  {
    name: 'penalty',
    label: 'pnl',
    width: 60,
    sectionId: 'section_4',
    aggregation_type: 'sum',
    isSelected: true
  },
  {
    name: '@@separator4',
    label: '—',
    isSelected: true
  },
  {
    name: 'message',
    label: 'message',
    width: 80,
    sectionId: 'section_5',
    aggregation_type: 'sum',
    isSelected: true
  },
  {
    name: 'gifts',
    label: 'gifts',
    width: 60,
    sectionId: 'section_5',
    aggregation_type: 'sum',
    isSelected: true
  },
  {
    name: 'presents',
    label: 'presents',
    width: 60,
    sectionId: 'section_5',
    aggregation_type: 'sum',
    isSelected: false
  },
  {
    name: 'call',
    label: 'call',
    width: 60,
    sectionId: 'section_5',
    aggregation_type: 'sum',
    isSelected: false
  },
  {
    name: 'video',
    label: 'video',
    width: 60,
    sectionId: 'section_5',
    aggregation_type: 'sum',
    isSelected: false
  }
];

export const reportsInitialState = {
  reports: {
    data: [],
    ui: {
      favorites: []
    },
    meta: {
      isLoading: false,
      hasError: false,
      loaded: false,
      in_process: null
    },
    filters: {
      startDate: moment().utc()
        .startOf('month')
        .hours(1),
      endDate: moment().utc()
        .endOf('month')
        .hours(1),
      grouping: {
        selected: null,
        options: []
      },
      status: {
        selected: null,
        options: []
      },
      columnSettings: {
        // default preset
        currentPresetId: 0,
        // presets from server
        availablePresets: [
          // preset model
          {
            id: 0,
            label: 'по умолчанию',
            columnsConfiguration: columns
          }
        ],
        lastSelectedPresetColumns: []
      },
      isDecimal: false,
      search: ''
    },
    selectors: {
      filteredData,
      isAllColumnsSelected,
      selectedPreset: selector(store => {
        const selectedPreset = store.reports.filters.columnSettings.availablePresets.find(
          preset => preset.id === store.reports.filters.columnSettings.currentPresetId
        );
        const { columnsConfiguration } = selectedPreset;
        let availableColumns = columns.map(col => col.name);
        let filteredColumns = columnsConfiguration.slice();

        switch (store.auth.accessLevel) {
          case ACCESS_LEVEL.operator: {
            availableColumns = [
              'status',
              'photo',
              'full_name',
              'team_lead',
              'operator',
              'nick',
              'id',
              'total',
              'operator_income',
              'pnl',
              'message'
            ];

            break;
          }
          case ACCESS_LEVEL.teamlead: {
            availableColumns = [
              'panel',
              'status',
              'photo',
              'full_name',
              'manager',
              'team_lead',
              'operator',
              'nick',
              'id',
              'number',
              'total',
              'plan',
              'teamlead',
              'operator_income',
              'pnl',
              'gifts',
              'call',
              'video',
              'message',
              'account_income',
            ];

            break;
          }
          case ACCESS_LEVEL.agency: {
            break;
          }
          case ACCESS_LEVEL.scout: {
            availableColumns = availableColumns.filter(col => {
              return col !== 'message' || col !== 'fee';
            });
            break;
          }
          case ACCESS_LEVEL.manager: {
            availableColumns = availableColumns.filter(col => {
              return col !== 'fee';
            });
            break;
          }
          default:
            break;
        }

        filteredColumns = columnsConfiguration.filter(
          column => availableColumns.includes(column.name) || column.name.includes('@@')
        );

        if (store.auth.currentHost === GRANTED_HOSTS.dm) {
          const columnConfig = filteredColumns.find(col => col.name === 'message');

          // since for some access level message column is invisible
          if (columnConfig) {
            columnConfig.label = 'message/chat';
            columnConfig.width = 100;
          }
        }

        return observable({ ...selectedPreset, columnsConfiguration: filteredColumns });
      }),
      currentPresetColumnsList: selector(store => {
        const { columnsConfiguration } = store.reports.selectors.selectedPreset;

        return columnsConfiguration.map(column => column.name);
      })
    }
  }
};
